<script lang="ts">
  // Import your icons and styles
  import { LabelButton } from "$components";

  export let title: string;
  export let onTitleClick: (() => void) | undefined = undefined;
  export let description: string | undefined = undefined;
  export let descriptionType: "error" | undefined = undefined;
  export let labelRight: string = "";
  export let onLabelRightClick: (() => void) | undefined = undefined;
  export let textRight: string = "";
  export let labelRightType: "info" | "success" | "error" | "disabled" =
    "info";
  export let textRightBold: boolean = false;
  export let isLast: boolean = false;
  export let isFirst: boolean = false;
  export let isSingleItem: boolean = false;
  export let leftIconSrc: string | undefined = undefined;
  export let iconSrc: string | undefined = undefined;
  export let onIconClick: (() => void) | undefined = undefined;
  export let customClass = "";
  export let disabled: boolean = false;
  export let link: string | (() => unknown) | undefined = undefined;
  export let linkExternal: boolean = false;

  $: borderRadiusClasses = `${
    isFirst || isSingleItem ? "rounded-t-md" : ""
  } ${isLast || isSingleItem ? "rounded-b-md" : ""}`;
</script>

<a
  class="list-navigation-item outset {borderRadiusClasses} {customClass}"
  class:opacity-50={disabled}
  role={undefined}
  aria-label="Close dialog"
  href={disabled ? "#" : typeof link === "string" ? link : undefined}
  onclick={disabled ? undefined : typeof link === "function" ? link : undefined}
  target={linkExternal ? "_blank" : "_self"}
  class:cursor-pointer={!disabled && typeof link === "function"}
>
  <div class="flex flex-1 items-center px-[16px]">
    {#if leftIconSrc}
      <img alt="left icon" class="mr-5" src={leftIconSrc} />
    {/if}
    <div class="flex-1">
      <span
        role={onTitleClick ? "button" : undefined}
        onclick={onTitleClick}
        class:cursor-pointer={!!onTitleClick}
        class="whitespace-nowrap text-ellipsis text-[14px]"
      >{title}</span>
      {#if description}
        <span
          class:text-error-bg={descriptionType === "error"}
          class="whitespace-nowrap text-ellipsis list-navigation-item-text"
        >{description}</span>
      {/if}
    </div>
    {#if labelRight}
      <span class="flex mr-[8px]">
        <LabelButton
          text={labelRight}
          onClick={onLabelRightClick}
          type={labelRightType}
        />
      </span>
    {/if}

    <span
      class:font-bold={textRightBold}
      class="whitespace-nowrap contents text-[#626262] {labelRightType}"
    >{textRight}<slot /></span>
    {#if iconSrc}
      <button
        aria-label="right button"
        onclick={onIconClick}
        class="p-4 -mr-4"
        {disabled}
      >
        <img alt="button icon" src={iconSrc} />
      </button>
    {:else if link}
      {#if linkExternal}
        <img src="/icons/new-window.svg" alt="external-link" />
      {:else}
        <img src="/icons/arrow-right-small.svg" alt="arrow-right" />
      {/if}
    {/if}
  </div>
</a>
